// Session lifetime, in milliseconds.
export const TIMEOUT_MILLIS = 30 * 60 * 1000;

// Warning time before session timeout, in milliseconds 
export const TIMEOUT_WARN_MILLIS = 1 * 60 * 1000;

// Snackbar timout duration in milliseconds
export const SNACKBAR_DURATION = 6000;
